import { getBinaryId } from '@seen/core/utils'

const FHIR_BINARY_PATH = /(?:^|\/)Binary\/([A-Za-z0-9._-]+)/

export function ccdaBinaryReference(url: string): string {
  const fromPath = url.match(FHIR_BINARY_PATH)
  if (fromPath?.[1]) {
    return `Binary/${fromPath[1]}`
  }

  try {
    const id = getBinaryId(url)
    if (id && id.toLowerCase() !== 'binary') {
      return `Binary/${id}`
    }
  } catch {
    // Not a storage URL either.
  }

  throw new Error('Invalid CCDA attachment URL')
}
